import type { ReactNode } from "react";

export function ErrorMessage({ error, defaultText = "Unknown error while contacting server" }: { error: unknown; defaultText?: string }) {
  return <div className="alert alert-error">{typeof error === "string" ? error : defaultText}</div>;
}

export function SuccessMessage({ children }: { children: ReactNode }) {
  return <div className="alert alert-success">{children}</div>;
}
